const events = {
  openSidebar: 'openSidebar',
  closeSidebar: 'closeSidebar',
};

export { events };
